import { Build } from "~/components/build/Show/lib/types";
import fetcher from "~/components/build/Show/lib/fetcher";
import { queryOptions, UseQueryOptions } from "@tanstack/react-query";

type TestEngineInfoResponse = {
  testEngine: {
    testTabUrl: string | null;
  };
};

export function testEngineInfoQueryKey(buildId: Build["id"]) {
  return ["build", buildId, "testEngineInfo"];
}

export function testEngineInfoQueryOptions(
  build: Build,
  queryOptionsArgs: Omit<UseQueryOptions<TestEngineInfoResponse>, "queryKey" | "queryFn"> = {},
) {
  if (!build) {
    throw new Error("build is required");
  }

  const options: UseQueryOptions<TestEngineInfoResponse> = {
    queryKey: testEngineInfoQueryKey(build.id),
    queryFn: ({ signal }) => fetchTestEngineInfo(build, signal),
    staleTime: Infinity,
    ...queryOptionsArgs,
  };

  return queryOptions(options);
}

function fetchTestEngineInfo(build: Build, signal: AbortSignal): Promise<TestEngineInfoResponse> {
  const url = new URL(`${build.buildDataBasePath}/test-engine-info`, window.location.origin);

  return fetcher<TestEngineInfoResponse>(url, true, { signal });
}
